module.exports = __webpack_public_path__ + "static/img/6bg_2.d87b6a8.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/6bg_2.png
// module id = 737
// module chunks = 1